import { PersistThings } from "../persist/persistThings";
import { IpaType } from "../phonemes/ipa";
import { RuleSet } from "./ruleSet";

const currentRulesVersion = 'rr1.1';
const rulesVersionOldLengths = 'rr1.0';
const rulesKey = 'rule';

let persist: PersistThings | null = null;
function getPersist(): PersistThings {
  if (persist === null) { persist = new PersistThings(rulesKey); }
  return persist;
}

/** get a list of names of all saved rules */
export function getSavedRuleList(): string[] {
  return getPersist().getSavedList();
}


/** save a custom rule set under the given name */
export function saveRule(ruleName: string, ruleSet: RuleSet, isNonRhotic?: boolean) {
  const toSave: RuleRecord = { version: currentRulesVersion, ruleSet, isNonRhotic };
  const text = JSON.stringify(toSave);
  getPersist().saveThing(ruleName, text);
}

/** get a saved custom rule, returns null if there were any problems */
export function loadRule(ruleName: string): { ruleSet: RuleSet, isNonRhotic?: boolean } | null {
  const text = getPersist().loadThing(ruleName);
  if (text !== null) {
    try {
      const record = JSON.parse(text) as RuleRecord;
      if (record.version === rulesVersionOldLengths && record.ruleSet) {
        return from10to11(record);
      } else if (record.version === currentRulesVersion && record.ruleSet) {
        return record;
      }
    } catch (error) { }
  }
  return null;
}

/** delete the custom rule stored under the given name */
export function deleteRule(ruleName: string) {
  getPersist().deleteThing(ruleName);
}

/** record for storing rules & metadata */
interface RuleRecord {
  readonly version: string; // currentRulesVersion
  readonly ruleSet: RuleSet;
  readonly isNonRhotic?: boolean;
}

/** upgrade an rr1.0 rule to rr1.1  */
function from10to11(record: RuleRecord): RuleRecord {
  const oldPhonemeLengths = record.ruleSet.phonemeLengths;
  if (oldPhonemeLengths === undefined) {
    return record;
  }
  const phonemeLengths: Record<IpaType, number> = oldPhonemeLengths as unknown as Record<IpaType, number>;
  const ruleSet: RuleSet = { ...record.ruleSet, phonemeLengths: { map: phonemeLengths } };
  return { ...record, ruleSet };
}